import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialDuoState = {
  canDebut: true,
};

const { actions, reducer } = createSlice({
  name: 'duo',

  initialState: initialDuoState,

  reducers: {
    setCanDebut: (duo, { payload }: PayloadAction<boolean>) => {
      duo.canDebut = payload;
    },
  },

  extraReducers: {
    RESET_APP: () => initialDuoState,
  },
});

export const duoActions = actions;
export default reducer;
